<div class="sideMenu" [class.shown]="this.appService.sideBarEstaVisivel">

    <a (click)="clickMenu(menu)" routerLink="/" class="Option" *ngFor="let menu of menuService.menu">
        <div [class.active]="menu.id === menuService.menuAtivo" class="button">
            <mat-icon fontSet="material-icons-outlined">{{menu.icon}}</mat-icon>
            <p>{{menu.title}}</p>
        </div>
    </a>

</div>